import { useMemo } from 'react'
import api from '../../lib/commons/api'
import {
  PermissionPolicyRepository,
  PermissionPolicyEntity,
} from '../../applications/ports/permissionPolicyRepository'

export const usePermissionPolicyRepository = (): PermissionPolicyRepository => {
  return useMemo(
    () => ({
      getList: async (): Promise<PermissionPolicyEntity[]> => {
        const response = await api.functional.request(
          'GET',
          '/api/v1/permission_policies'
        )
        return response.json as PermissionPolicyEntity[]
      },
    }),
    []
  )
}
